<template>
<div>
      <filters :sorting="sorting" :order="order" v-model="query"></filters>
      <div class="main-content-wrapper">
        <div class="container">
          <div class="col-md-12 mobile-col">
            <main-menu 
              :menudeals="menudeals" 
              :menubottles="menubottles"
              :menuhalfs="menuhalfs"
              :menumagnums="menumagnums"
              :menuglass="menuglass"
              ></main-menu>
            <div class="col-md-9">
              <div id="myProgress">
                  <div id="myBar"></div>
              </div>
              <div id="myProgress2">
                  <div id="myBar2"></div>
              </div>
              <br>
              <div class="wines-holder">
                <div v-for="(group,key,index) in groupedproducts" :key="index">
                  <div class="col-md-12 subtitle">
                    <h2>{{ key }}</h2>
                  </div>
                  <!-- <div class="col-md-12 titles">
                    <span class="number">#</span>
                    <span>Name</span>
                    <span class="alignright">Price</span>
                  </div> -->

                  <div class="col-md-12">
                          <div class="panel-group" :id="'accordion-'+index" v-if="group.length">
                          <div class="panel panel-default" v-for="product in group" :key="product.item_id">
                        <div class="panel-heading">
                          <h4 class="panel-title">
                          <a data-toggle="collapse" :data-parent="'#accordion-'+index" :href="'#collapse'+product.item_id">
                            <div class="alignleft number"><span class="number-mobile">#</span>{{product.wine_data.bin_number}}</div>
                            <div class="alignleft product-name">{{ product.name }}, {{ product.wine_data.year }}</div>
                            <div class="alignright price" v-if="glass!=true">{{ '$'+parseInt(product.price) }}</div>
                            <div class="alignright price" v-if="glass==true">{{ '$'+parseInt(product.wine_data.glass_price) }}</div>
                            <div class="alignright old-price price" v-if="club==true && parseInt(product.wine_data.original_sale_price)>0">{{ '$'+parseInt(product.wine_data.original_sale_price) }}</div>
                            <div class="alignright promo-price" v-if="(product.wine_data.wine_ratings[0] && showrating==true)">{{ product.wine_data.wine_ratings[0].rating }}</div>
                          </a>
                          </h4>
                        </div>
                        <div :id="'collapse'+product.item_id" class="panel-collapse collapse">
                          <div class="panel-body">
                            <div class="row">
                              <div class="col-md-3 aligncenter">
                                <div class="row">
                                  <div class="wine-img-holder">
                                    <img :src="'https://libertyhouserestaurantmanagement.com'+product.image" />
                                  </div>
                                  <p>
                                    <span class="orange">Year: </span><span>{{ product.wine_data.year }}</span><br>
                                    <span class="orange">Type: </span><span>{{ product.wine_data.wine_type.name }}</span><br>
                                    <span class="orange">Price: </span><span>{{ '$'+parseInt(product.price) }} Bottle</span><br>
                                    <span class="orange">Availability: </span><span>{{ formatStock(product.in_stock) }}</span><br>
                                    <span class="orange" v-if="(product.wine_data.wine_ratings[0])">Rating:</span><span v-if="(product.wine_data.wine_ratings[0])"> {{ product.wine_data.wine_ratings[0].rating }} </span>
                                  </p>
                                </div>
                              </div>
                              <div class="col-md-9">{{ product.wine_data.story }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p v-if="!group.length">No results</p>
                    </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Filters from './components/Filters'
import MainMenu from './components/MainMenu'

export default {
  name: 'App',
  components: {
    'filters': Filters,
    'main-menu': MainMenu
  },
  data () {
            return {
              sorting: 'price',
              order: 'asc',
              club: true,
              bottle: false,
              half: false,
              magnum: false,
              glass: false,
              wine_type: 0,
              grape: 0,
              country: 0,
              region: 0,
              showrating: false,
                products: [],
                countries: [],
                wine_types: [],
                groups: [],
                query: ''
            }
        },
        
        
        methods: {
                  formatStock(i) {
                    if(parseInt(i)>6)
                      return '6+';
                    else
                      return parseInt(i);
                  },

                  compareByPrice(a, b) {
                    if(this.order=='asc') {
                      if (parseInt(a.price) < parseInt(b.price))
                        return -1;
                      if ( parseInt(a.price) > parseInt(b.price))
                        return 1;
                      } else
                        {
                          if (parseInt(a.price) < parseInt(b.price))
                            return 1;
                          if ( parseInt(a.price) > parseInt(b.price))
                            return -1;
                      }
                    return 0;
                  },

                  compareByName(a, b) {
                      if(this.order=='asc'){
                        if (a.name < b.name) {
                            return -1; }
                          if ( a.name > b.name) {
                            return 1; }
                      } else {
                          if (a.name < b.name) {
                            return 1; }
                          if ( a.name > b.name) {
                            return -1; }
                      }
                      return 0;
                  },

                  compareByVintage(a, b) {
                    if(this.order=='asc') {
                      if (parseInt(a.wine_data.year) < parseInt(b.wine_data.year))
                          return -1;
                      if ( parseInt(a.wine_data.year) > parseInt(b.wine_data.year))
                          return 1;
                    } else {
                        if (parseInt(a.wine_data.year) < parseInt(b.wine_data.year))
                          return 1;
                        if ( parseInt(a.wine_data.year) > parseInt(b.wine_data.year))
                          return -1;
                    }
                    return 0;
                  },

                  compareByRating(a, b) {
                    if(this.order=='desc'){
                      if(a.wine_data.wine_ratings.length === 0)
                        return 1;
                      if(b.wine_data.wine_ratings.length === 0) 
                        return -1;
                      if(a.wine_data.wine_ratings.length == 0 && b.wine_data.wine_ratings.length == 0) 
                        return 0;
                      if (parseInt(a.wine_data.wine_ratings[0].rating) > parseInt(b.wine_data.wine_ratings[0].rating))
                        return -1;
                      if ( parseInt(a.wine_data.wine_ratings[0].rating) < parseInt(b.wine_data.wine_ratings[0].rating))
                        return 1;
                    }
                    else 
                    {
                      if(a.wine_data.wine_ratings.length === 0)
                          return -1;
                        if(b.wine_data.wine_ratings.length === 0) 
                          return 1;
                        if(a.wine_data.wine_ratings.length == 0 && b.wine_data.wine_ratings.length == 0) 
                          return 0;
                        if (parseInt(a.wine_data.wine_ratings[0].rating) > parseInt(b.wine_data.wine_ratings[0].rating))
                          return -1;
                        if ( parseInt(a.wine_data.wine_ratings[0].rating) < parseInt(b.wine_data.wine_ratings[0].rating))
                          return 1;
                    }
                      return 0;
                  }
					  },
            
            
            computed: {
                	menudeals() {
                    var temp_products = this.products;
                    temp_products = _.filter(temp_products, 
                                    function(item){
                                return item.wine_data.is_club == "1";
                            });
                    var categories = this.groups;
                    var wines = this.wine_types;
                    var wine_types = _.groupBy(temp_products, function(item) {
                      return item.wine_data.wine_type_id;
                    });
                    var wines_ids = _.keys(wine_types);

                    var menu = [];
                    //var submenu;
                    _.forEach(wines, function(value, key) {
                      if(wines_ids.indexOf(value.wine_type_id) > -1){
                        //submenu = _.filter(sorts_items, ['id', value.wine_type_id]);
                        menu.push({
                          id: value.wine_type_id,
                          name: value.name
                          //submenu: submenu[0].items
                        });
                      }
                    });
                    return menu;
                	},
                	menubottles() {
                      var temp_products = this.products;

                      temp_products = _.filter(temp_products,
                                        function(item){
                                  return item.wine_data.bottle_size == "750";
                              });
                      var categories = this.groups;
                      var countries = this.countries;
                      var wines = this.wine_types;
                      var wine_types = _.groupBy(temp_products, function(item) {
                        return item.wine_data.wine_type_id;
                      });
                      var wines_ids = _.keys(wine_types);
                      var sorts_items = [];
                      
                      _.forEach(wine_types, function(value, key) {
                        var wines_sorts = [];
                        var countries_list = [];
                        var sorts = [],
                          current_category,
                          current_category_id;

                          sorts = _.groupBy(value, function(item) {
                                  if(item.item_category.parent_id==null){
                                                return item.item_category.item_category_id;		
                                            }
                                            else {
                                              var cat = _.filter(categories,{'item_category_id':item.item_category.parent_id});
                                              return cat[0].item_category_id;
                                            }
                            });
                          var sorts_ids = _.keys(sorts);
                          _.forEach(categories,
                            function(cat){
                              if(sorts_ids.indexOf(cat.item_category_id) > -1)
                              {
                                if(cat.parent_id==null)
                                  wines_sorts.push({
                                    id: cat.item_category_id,
                                    name: cat.name,
                                    position: cat.position
                                  });
                                else {
                                  var parent_cat = _.filter(categories, ['item_category_id', cat.parent_id]);
                                  wines_sorts.push({
                                    id: parent_cat.item_category_id,
                                    name: parent_cat.name,
                                    position: parent_cat.position
                                  });
                                }
                              }
                            });
                          wines_sorts = _.uniqBy(wines_sorts,'id');
                          
                          wines_sorts = _.sortBy(wines_sorts,[function(so){ return parseInt(so.position);}]);
                          

                          // countries
                          let group_by_country = _.groupBy(value, function(item) {
                              return item.wine_data.wine_country_id;
                            });
                          _.forEach(group_by_country,
                            function(rows, key){
                              var country = _.filter(countries,function(cou){
                                return cou.wine_country_id == key
                              });
                              var rows_regions =  _.omitBy(rows, _.isNil);
                              var path = 'wine_data.wine_region_id';
                              var regions = _(rows_regions)
                                .filter(row => _.has(row, path))
                                .groupBy(path)
                                .value();
                              // var regions = _.groupBy(rows,wine_data.wine_region_id)
                              // console.log(regions);
                              // console.log(country);
                              var regions_ids = _.keys(regions);
                              var regions_list = [];
                              if(country.length) {
                                _.forEach(country[0].regions,
                                  function(reg, key){
                                    if(regions_ids.indexOf(reg.wine_region_id) > -1)
                                      regions_list.push({
                                        id: reg.wine_region_id,
                                        name: reg.name
                                      });
                                  });
                                countries_list.push({
                                      id: key,
                                      name: country[0].name,
                                      position: country[0].position,
                                      regions: regions_list
                                    });
                              }
                            });
                          
                          countries_list = _.sortBy(countries_list,[function(co){ return parseInt(co.position);}]);

                          sorts_items.push({
                            id: key,
                            countries: countries_list,
                            items: wines_sorts//_.uniqBy(sorts,'item_id')
                          });
                      });	

                      var menu = [];
                      var submenu;
                      _.forEach(wines, function(value, key) {
                        if(wines_ids.indexOf(value.wine_type_id) > -1){
                          
                          submenu = _.filter(sorts_items, ['id', value.wine_type_id]);

                          menu.push({
                            id: value.wine_type_id,
                            name: value.name,
                            countries: submenu[0].countries,
                            sorts: submenu[0].items
                          });
                        }
                      });
                      return menu;
                	},
                	menuhalfs() {
                      var temp_products = this.products;
                      temp_products = _.filter(temp_products,
                                        function(item){
                                  return item.wine_data.bottle_size < "750";
                              });
                      var categories = this.groups;
                      var wines = this.wine_types;
                      var wine_types = _.groupBy(temp_products, function(item) {
                        return item.wine_data.wine_type_id;
                      });
                      var wines_ids = _.keys(wine_types);

                      var menu = [];
                      var submenu;
                      _.forEach(wines, function(value, key) {
                        if(wines_ids.indexOf(value.wine_type_id) > -1){
                          
                          //submenu = _.filter(sorts_items, ['id', value.wine_type_id]);

                          menu.push({
                            id: value.wine_type_id,
                            name: value.name
                            //sorts: submenu[0].items
                          });
                        }
                      });
                      return menu;
                	},
                	menumagnums() {
                      var temp_products = this.products;
                      temp_products = _.filter(temp_products,
                                        function(item){
                                  return parseInt(item.wine_data.bottle_size) > 750;
                              });
                      var categories = this.groups;
                      var wines = this.wine_types;
                      var wine_types = _.groupBy(temp_products, function(item) {
                        return item.wine_data.wine_type_id;
                      });
                      var wines_ids = _.keys(wine_types);

                      var menu = [];
                      var submenu;
                      _.forEach(wines, function(value, key) {
                        if(wines_ids.indexOf(value.wine_type_id) > -1){
                          
                          // submenu = _.filter(sorts_items, ['id', value.wine_type_id]);

                          menu.push({
                            id: value.wine_type_id,
                            name: value.name
                            // sorts: submenu[0].items
                          });
                        }
                      });
                      return menu;
                	},
                	menuglass() {
                      var temp_products = this.products;
                      temp_products = _.filter(temp_products,
                                        function(item){
                                  return parseInt(item.wine_data.glass_price) > 0 && 
                                  item.wine_data.is_sold_by_glass == "1";
                              });
                      var categories = this.groups;
                      var wines = this.wine_types;
                      var wine_types = _.groupBy(temp_products, function(item) {
                        return item.wine_data.wine_type_id;
                      });
                      var wines_ids = _.keys(wine_types);
                      
                      var menu = [];
                      var submenu;
                      _.forEach(wines, function(value, key) {
                        if(wines_ids.indexOf(value.wine_type_id) > -1){
                          
                          // submenu = _.filter(sorts_items, ['id', value.wine_type_id]);

                          menu.push({
                            id: value.wine_type_id,
                            name: value.name
                            // sorts: submenu[0].items
                          });
                        }
                      });
                      return menu;
                	},
                	filteredproducts() {
                    	var temp_products = this.products;
                    	var categories = this.groups;
                    	var current_wine_type = this.wine_type;
                    	var current_grape = this.grape;
                    	var current_country = this.country;
                    	var current_region = this.region;
                    	var query = this.query.toLowerCase();
                    	if(this.query!='')
                        	temp_products = _.filter(temp_products,
	                    				function(item){
											  return String(item.wine_data.story).toLowerCase().indexOf(query) > -1 
											  || String(item.name).toLowerCase().indexOf(query) > -1;
										});
                        // this.products.filter((row) => {
                        //   		return Object.keys(row).some((key) => {
                        //     		return String(row[key]).toLowerCase().indexOf(this.query) > -1
                        //  		})
                        // 	});

                        // filter by attribute
                        // if(this.club)
	                       //  temp_products = temp_products.filter((row) => {
	                       //      return row.wine_data.is_club == "1"
	                          
	                       //  });
                        if(this.club)
	                    	temp_products = _.filter(temp_products, 
	                					function(item){
											  return item.wine_data.is_club == "1";
										});
	                	if(this.wine_type>0) {
	                    	temp_products = _.filter(temp_products, 
	                					function(item){
											  return item.wine_data.wine_type.wine_type_id == current_wine_type;
										});
	                	}
	                    if(this.bottle)
	                    	temp_products = _.filter(temp_products,
	                    				function(item){
											  return item.wine_data.bottle_size == "750";
										});
	                    if(this.country>0) {
	                    	temp_products = _.filter(temp_products, 
	                					function(item){
											  return item.wine_data.wine_country_id == current_country;
										});
	                	}
	                	if(this.region>0) {
	                    	temp_products = _.filter(temp_products, 
	                					function(item){
											  return item.wine_data.wine_region_id == current_region;
										});
	                	}
	                    if(this.half)
	                    	temp_products = _.filter(temp_products,
	                    				function(item){
											  return parseInt(item.wine_data.bottle_size) < 750;
										});
	                    if(this.magnum)
	                    	temp_products = _.filter(temp_products,
	                    				function(item){
											  return parseInt(item.wine_data.bottle_size) > 750;
										});
	                    if(this.glass)
	                    	temp_products = _.filter(temp_products,
	                    				function(item){
											  return item.wine_data.glass_price > "0.00" && 
											  item.wine_data.is_sold_by_glass == "1";
										});

	                    if(this.grape>0)
	                    	temp_products = _.filter(temp_products, function(row){
	                    	 			return (row.item_category.item_category_id == current_grape) ||
										 (row.item_category.parent_id == current_grape);
	                    	 			});

                        var unique = _.uniqBy(temp_products,'item_id');
                        return unique;
                	},
                  groupedproducts () {
                    // return [];
                    var temp_products = this.filteredproducts;
                    var temp_categories = this.groups;

                      var grouped = _.groupBy(temp_products,function(item){
                                if(item.item_category.parent_id==null){
                                    return item.item_category.name;		
                                }
                                else {
                                  var cat = _.filter(temp_categories,{'item_category_id':item.item_category.parent_id});
                                  return cat[0].name;
                                }
                      // return item.item_category.name;
                      });
                    switch(this.sorting) {
                      case 'name':
                        for(let r in grouped){
                          grouped[r] = grouped[r].sort(this.compareByName);
                        }
                          return grouped;//temp_products.sort(this.compareByName);
                          break;
                      case 'price':
                        for(let r in grouped){
                            grouped[r] = grouped[r].sort(this.compareByPrice);
                          }
                          return grouped;
                          break;
                      case 'vintage':
                        for(let r in grouped){
                            grouped[r] = grouped[r].sort(this.compareByVintage);
                          }
                          return grouped;
                          // return temp_products.sort(this.compareByVintage);
                          break;
                      case 'rating':
                        for(let r in grouped){
                            grouped[r] = grouped[r].sort(this.compareByRating);
                          }
                          return grouped;
                          // return temp_products.sort(this.compareByRating);
                          break;
                    }
                  }       
            },


            mounted () {

              $(function(){
                  $(".menu-item").click(function(){
                    $(this).toggleClass("active");
                      $(this).find("ul.submenu").slideToggle();
                  });
              });
                    var self = this;
            		var wine_sorts = [];

            		$.when(
            			$.post("https://libertyhouserestaurantmanagement.com/api/v2/bones_restaurant/get-wine-types",
	                    {
	                    	
	                    })
	                    .then(function(data) {
	                    		self.wine_types = data.result;
	                    		self.wine_types = _.sortBy(self.wine_types, ['position']);
                    	}),
                    	$.post("https://libertyhouserestaurantmanagement.com/api/v2/bones_restaurant/get-wine-countries",
	                    {
	                    	
	                    })
	                    .then(function(data) {
	                    		self.countries = data.result;
                    	}),
	                    $.post("https://libertyhouserestaurantmanagement.com/api/v2/bones_restaurant/get-item-categories",
	                    {
	                    	"item_type": "wine"
	                    })
	                    .then(function(data) {
	                    		self.groups = data.result;
	                    		self.groups = _.sortBy(self.groups, ['position']);
	                    		self.groups.forEach(function(category) {
                				var cat_id = category.item_category_id;
                				var cat_name = category.name;
                    			var sub_categories = category.subcategories;
                    			$.post("https://libertyhouserestaurantmanagement.com/api/v2/bones_restaurant/get-wine-items", 
                    				{
                              "item_category_id": cat_id,
                              //"is_club": "1",
                              //"bottle_size": 0,
                              // "by_the_glass": 0,
                              // "country_id": 0,
                              // "region_id": 0
                            }
		                        )
		                        .done(function (data) {
		                            for(let row in data.result){
		                            	if(data.result.length>0){
		                            		wine_sorts.push({
		                            			id: cat_id,
		                            			name: cat_name
		                            		})
		                            		if(typeof data.result[row] ==="object")
		                            			self.products.push(data.result[row]);
		                        		}
		                            }

		                        });

	                            // if subcategories
		                        if(sub_categories!==undefined)
		                        	if(sub_categories.length>0)
		                            	{
		                            		for(let j in sub_categories){
			                            		var subcat_id = sub_categories[j].item_category_id;
			                            		$.post("https://libertyhouserestaurantmanagement.com/api/v2/bones_restaurant/get-wine-items", 
				                    				{
													  "item_category_id": subcat_id,
													  // "is_club": "1",
													  // "bottle_size": 0,
													  // "by_the_glass": 0,
													  // "country_id": 0,
													  // "region_id": 0
													}
						                        )
						                        .done(function (data) {
						                            for(let subrow in data.result){
						                            	if(data.result.length>0){
		                            						if(typeof data.result[subrow] ==="object")
						                            			self.products.push(data.result[subrow]);
						                            	}
				                            		}
			                            		})
		                            		}
		                            	}
                            });	
							    
                    		})

                	).done(function(){
                	}),
                    

			        bus.$on('app:sortby', (sorting) => {
			        	if(this.order=='asc')
			        		this.order='desc';
			        	else
			        		this.order='asc';
            			this.sorting=sorting;
        			}),
        			bus.$on('app:showrating', () => {
            			this.showrating=!this.showrating;
        			}),
        			bus.$on('app:menu:deals', (id) => {
            			this.club=true;
            			this.glass = false;
            			this.bottle = false;
            			this.half = false;
            			this.magnum = false;
            			this.region = 0;
            			this.country = 0;
            			this.grape = 0;
            			this.wine_type= parseInt(id);
        			}),
        			bus.$on('app:menu:bottles', (id) => {
            			this.bottle = true;
            			this.club = false;
            			this.glass = false;
            			this.half = false;
            			this.magnum = false;
            			this.region = 0;
            			this.grape = 0;
            			this.country = 0;
            			this.wine_type = parseInt(id);
        			}),
        			bus.$on('app:menu:half', (id) => {
            			this.half = true;
            			this.bottle = false;
            			this.magnum = false;
            			this.glass = false;
            			this.club = false;
            			this.region = 0;
            			this.grape = 0;
            			this.country = 0;
            			this.wine_type = parseInt(id);
        			}),
        			bus.$on('app:menu:magnum', (id) => {
            			this.magnum = true;
            			this.bottle = false;
            			this.half = false;
            			this.glass = false;
            			this.club = false;
            			this.grape = 0;
            			this.region = 0;
            			this.country = 0;
            			this.wine_type = parseInt(id);
        			}),
        			bus.$on('app:menu:glass', (id) => {
			        	this.glass = true;
            			this.magnum = false;
            			this.bottle = false;
            			this.half = false;
            			this.club = false;
            			this.grape = 0;
            			this.region = 0;
            			this.country = 0;
            			this.wine_type = parseInt(id);
        			}),
        			bus.$on('app:menu:grape', (id) => {
            			this.grape = parseInt(id);
            			this.region = 0;
            			this.country = 0;
        			}),
        			bus.$on('app:menu:region', (id) => {
            			this.region = parseInt(id);
            			this.grape = 0;
        			}),
        			bus.$on('app:menu:country', (id) => {
            			this.country = parseInt(id);
            			this.region = 0;
            			this.grape = 0;
              })
              
            }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue